import * as React from 'react';
import IconBadge from 'src/IconBadge';
import Search from 'src/icons/Search';
import PlainTextInput from 'src/inputs/PlainTextInput';
import type {InputProps} from 'src/inputs/TextInputBase';

const SearchInput = (props: InputProps) => {
  const {className, ...rest} = props;
  return (
    <IconBadge icon={<Search />}>
      <PlainTextInput className={`w-full ${className ?? ''}`} {...rest} />
    </IconBadge>
  );
};

export default SearchInput;
